// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cn19t","right":"styles_right__3JW1a"};